import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded'})
};

@Injectable({
  providedIn: 'root'
})
export class ApiInvService {

  public serverUrl='http://localhost:8080/webapp/';
  constructor(private http:HttpClient) { }

  post(formValue,url):Observable<any>
  {
    return this.http.post<any>(this.serverUrl+url,formValue,httpOptions).pipe(
      catchError(this.handleErros)
    );
  }

  get(url):Observable<any>
  {
    return this.http.get<any>(this.serverUrl+url,httpOptions).pipe(
      catchError(this.handleErros)
    );
  }

  handleErros(error:HttpErrorResponse){
    return throwError(error);
  }
}
